﻿export type RuleQualityFacet = 'crossPalace' | 'dignity' | 'transformation' | 'counter' | 'compound';

export interface RuleQualityResearchHold {
  dimension: string;
  facet: RuleQualityFacet;
  status: 'research_hold';
  reason: string;
}

export interface RuleQualityResearchPolicy {
  id: 'RULE-QUALITY-RESEARCH-POLICY';
  version: '0.1.0';
  holds: readonly RuleQualityResearchHold[];
  disclosure: string;
}

export const PRODUCTION_RULE_QUALITY_RESEARCH_POLICY_0_1_0: RuleQualityResearchPolicy = Object.freeze({
  id: 'RULE-QUALITY-RESEARCH-POLICY',
  version: '0.1.0',
  holds: Object.freeze<RuleQualityResearchHold[]>([
    { dimension:'career_role_stability', facet:'transformation', status:'research_hold', reason:'尚無足夠精確的官祿宮專屬四化原文；通用四化條文不得直接改寫成事業結果 Rule。' },
    { dimension:'wellbeing_transformation_context', facet:'crossPalace', status:'research_hold', reason:'古籍明示福德對財帛，但尚未建立可避免空泛重複的特定跨宮條件。' },
    { dimension:'resource_management', facet:'crossPalace', status:'research_hold', reason:'需找到財帛宮三方／對宮具體星曜或四化條件，不能只因一般三方原則補 Rule。' },
    { dimension:'resource_management', facet:'dignity', status:'research_hold', reason:'需確認財帛宮四化與同星亮度的直接或可清楚拆分來源後再建 compound Rule。' },
    { dimension:'sibling_coordination_context', facet:'transformation', status:'research_hold', reason:'兄弟宮四化條文多含人數與家庭制度結果，安全抽象前不進 production。' },
    { dimension:'support_network_reliability', facet:'transformation', status:'research_hold', reason:'奴僕宮原文具歷史主僕語境；尚未有足夠乾淨的四化條件可直接轉為現代支持網絡 Evidence。' },
  ]),
  disclosure: 'Research hold 是防止為補齊 audit facet 而製造無來源規則；只有取得可定位來源並完成安全抽象後才能解除。',
});

export function ruleQualityResearchHold(dimension: string, facet: RuleQualityFacet): RuleQualityResearchHold | undefined {
  return PRODUCTION_RULE_QUALITY_RESEARCH_POLICY_0_1_0.holds.find((item) => item.dimension === dimension && item.facet === facet);
}

